'use client'
import React from 'react';
import {  CheckSquareOutlined } from "@ant-design/icons";
import  Image from 'next/image'
import GetQuteTip from "@/components/Service/CNC/GetQuteTip";
import { useTranslations } from "next-intl";
import CusTitle from "@/components/Home2/CusTitle.tsx";
import GetInstantQuoteButton from '../Contact/GetInstantQuote';
interface QualityItemProps {
	title: string;
	description: string;
}

const QualityItem: React.FC<QualityItemProps> = ({ title, description }) => {
	return (
		<div className="flex items-start  space-x-3 animate__animated animate__fadeInUp mb-6">
			<CheckSquareOutlined  className="!text-blue-500 text-2xl mt-1 " />
			<div>
				<h4 className="font-semibold text-lg">{title}</h4>
				<p className="text-gray-600">{description}</p>
			</div>
		</div>
	);
};

const WhyChoose= () => {
	const t=useTranslations()
	return (
		<div className="container  py-32 max-md:py-16 px-4 ">
			<div className="flex flex-col md:flex-row md:space-x-8 ">
				{/* 左侧文本内容 */}
				<div className="md:w-1/2 animate__animated animate__fadeInLeft flex flex-col justify-between">
					<CusTitle className="text-4xl font-bold  pt-0 pb-8" homeTitle={t('qualityAssurance.whyLs')}></CusTitle>
					{/* Quality Item 列表 */}
					<QualityItem
						title={t("qualityAssurance.q1")}
						description={t("qualityAssurance.a1")}
					/>
					<QualityItem
						title={t("qualityAssurance.q2")}
						description={t("qualityAssurance.a2")} />
					<QualityItem
						title={t("qualityAssurance.q3")}
						description={t("qualityAssurance.a3")} />
					<QualityItem
						title={t("qualityAssurance.q4")}
						description={t("qualityAssurance.a4")} />
					<div className="mt-5">
						<div className="flex items-center">
							<Image src="/image/service/tips.png" width={25} height={20} alt="material Selection bottom" quality={50}
										 className="w-[25px] h-[24px] object-cover"></Image>
							<div className={`text-[15px] font-bold  max-md:py-3 pl-5`}>{t("qualityAssurance.quoteTip")}
							</div>
						</div>
						<GetInstantQuoteButton className="!justify-start mt-5"></GetInstantQuoteButton>
					</div>
				</div>
				{/* 右侧图片 */}
				<div className="md:w-1/2 w-full mt-8 md:mt-0 animate__animated animate__fadeInRight">
					<Image
						src="/image/quality-assurance/质控-配图.jpg"
						width={1000}
						height={1000}
						quality={70}
						alt="Quality Control Image"
						className="h-full w-full  object-cover"
					/>
				</div>
			</div>


		</div>
	);
};

export default WhyChoose;
